export default "__VITE_ASSET__DUCNAWWo__"